import { Component, OnInit } from '@angular/core';
import { ClienteService } from 'src/app/services/cliente.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-contacto',
  templateUrl: './contacto.component.html',
  styleUrls: ['./contacto.component.css']
})
export class ContactoComponent implements OnInit {
  public mensaje :any = {

  };
  public enviando = false;
  public formularioIntentado = false;
  public estadoFormulario = '';

  constructor(
    private _clienteService : ClienteService
  ) { }

  ngOnInit(): void {
  }



  enviar_mensaje(contactoForm)
  {
    this.formularioIntentado = true;
    contactoForm.control.markAllAsTouched();

    const camposRequeridos = ['nombres', 'email', 'asunto', 'telefono', 'mensaje'];
    const hayCamposVacios = camposRequeridos.some(campo => {
      const valor = this.mensaje[campo];
      return typeof valor !== 'string' || !valor.trim();
    });

    if(contactoForm.invalid || hayCamposVacios || this.enviando)
    {
      this.estadoFormulario = 'Revisa los campos marcados antes de enviar tu mensaje.';
      return;
    }

    this.enviando = true;
    this.estadoFormulario = 'Enviando mensaje...';
      this._clienteService.enviar_mensaje(this.mensaje).subscribe(
        response =>{
          Swal.fire({
            icon:'success',
            text:'Su mensaje ha sido enviado'
          })

          this.mensaje={}
          this.enviando = false;
          this.formularioIntentado = false;
          this.estadoFormulario = 'Mensaje enviado correctamente. Nos pondremos en contacto contigo.';

        },
        error=>{
          Swal.fire({
            icon:'error',
            text:'No pudimos enviar tu mensaje. Verifica tu conexión e inténtalo nuevamente.'
          })
          this.enviando = false;
          this.estadoFormulario = 'No pudimos enviar tu mensaje. Verifica tu conexión e inténtalo nuevamente.';
        }
      )
  }

}
